import { Color } from '@eversports/design-tokens/palette'

import { ColorContrast } from './Header.types'

export const textColorContrastMapping: { [key in ColorContrast]: Color } = {
  [ColorContrast.INVERTED]: 'white',
  [ColorContrast.NORMAL]: 'midnight',
}
